import React from 'react';

import { SnackbarProvider } from 'notistack';

import Button from '@material-ui/core/Button';
import Close from '@material-ui/icons/Close';

import { AlertMsgProvider } from './snackBar';
import LoadingBar from '../components/LoadingBar'

const notistackRef = React.createRef();
const onClickDismiss = key => () => { notistackRef.current.closeSnackbar(key); }

const AppProvider = ({ children }) => {
    return (
        <>
            <SnackbarProvider maxSnack={1} ref={notistackRef} action={(key) => (<Button onClick={onClickDismiss(key)}><Close /></Button>)}>
                <AlertMsgProvider >
                    { children }
                </AlertMsgProvider>
            </SnackbarProvider>
            <LoadingBar />
        </>
    )
}

export default AppProvider;